/* eslint-disable react/no-danger */
import * as React from 'react';

import type { SearchProductHit } from 'bundles/search-common/providers/searchTypes';
import { clearEmptyFields } from 'bundles/seo/utils/utils';

type Props = {
  hits?: SearchProductHit[];
};

const ResultsGoogleSchemaMarkup = ({ hits }: Props) => {
  if (!hits) {
    return null;
  }

  const markupJson = {
    '@context': 'http://schema.org',
    '@type': 'ItemList',
    itemListElement: hits.map((hit, i) => ({
      '@type': 'ListItem',
      position: i + 1,
      url: `https://www.coursera.org${hit.url}`,
    })),
  };

  const createMarkup = () => ({
    __html: `
      <script type="application/ld+json">
        ${JSON.stringify(clearEmptyFields(markupJson))}
      </script>
    `,
  });

  return <div dangerouslySetInnerHTML={createMarkup()} />;
};

export default ResultsGoogleSchemaMarkup;
